import { Map } from "immutable"

import PresentationReducerBuilder from "./build-presentation-reducer"
import {
    STUDIO_DIMENSION_WIZARD_REQUEST,
    STUDIO_DIMENSION_WIZARD_RESPONSE,
    STUDIO_CREATE_DIMENSION_APPLY_MODEL_UPDATE as APPLY_MODEL_UPDATE,
    STUDIO_CREATE_DIMENSION_UPDATE_MODEL as UPDATE_MODEL,
    STUDIO_CREATE_DIMENSION_SAVE_RESPONSE as ITEM_RESPONSE,
    STUDIO_CREATE_DIMENSION_CANCEL,
} from "../../actions/action-types"
import {
    DimensionModel,
    updateDimensionChangeModel
} from "../../models/entities/dimension"

const reducerBuilder = new PresentationReducerBuilder()
const defaultReducer = reducerBuilder
    .actionsToHandle({
        ITEM_RESPONSE,
        UPDATE_MODEL,
        APPLY_MODEL_UPDATE
    })
    .updateChangeModel(updateDimensionChangeModel)
    .workingModelClass(DimensionModel)
    .canSave(
        (updateModel, _, workingModel) =>
            workingModel.name.length > 0 && workingModel.topics.length > 0
    )
    .defaultState({
        workingModel: new DimensionModel(),
        isFetchingWizard: false,
        error: null
    })
    .build()

export default (state = undefined, action) => {
    const newDefaultState = defaultReducer(state, action)
    const { type, data, error } = action
    switch (type) {
        case STUDIO_DIMENSION_WIZARD_REQUEST:
            return {
                ...newDefaultState,
                isFetchingWizard: true
            }
        case STUDIO_DIMENSION_WIZARD_RESPONSE:
            let { workingModel, updateModel } = newDefaultState
            if ((data || {}).extract) {
                workingModel = workingModel.set("description", data.extract)
                updateModel = updateModel.set("description", data.extract)
            }
            return {
                ...newDefaultState,
                isFetchingWizard: false,
                workingModel,
                updateModel,
                error: error && "Error Message"
            }
        case STUDIO_CREATE_DIMENSION_CANCEL:
        case ITEM_RESPONSE:
            return {
                ...newDefaultState,
                workingModel: new DimensionModel(),
                updateModel: new Map(),
                error: null
            }
        default:
            return newDefaultState
    }
}
